export default __webpack_public_path__ + "static/media/maidan-nezalejnosti.e1205822.jpg";